import { render, staticRenderFns } from "./DashedFact.vue?vue&type=template&id=26061e08&scoped=true&"
import script from "./DashedFact.vue?vue&type=script&lang=js&"
export * from "./DashedFact.vue?vue&type=script&lang=js&"
import style0 from "./DashedFact.vue?vue&type=style&index=0&id=26061e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26061e08",
  null
  
)

export default component.exports